import { Loader2 } from 'lucide-react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { useAuth } from './lib/auth';
import { BackgroundsPage } from './pages/BackgroundsPage';
import { BrandPage } from './pages/BrandPage';
import { CharactersPage } from './pages/CharactersPage';
import { DirectorPage } from './pages/DirectorPage';
import { GpuPage } from './pages/GpuPage';
import { LoginPage } from './pages/LoginPage';
import { ProductsPage } from './pages/ProductsPage';
import { ProjectPage } from './pages/ProjectPage';
import { ProjectsPage } from './pages/ProjectsPage';
import { UsersPage } from './pages/UsersPage';

export function App() {
  const { me, loading, isAdmin } = useAuth();
  if (loading)
    return (
      <div className="grid min-h-screen place-items-center text-muted-foreground">
        <Loader2 className="size-6 animate-spin" />
      </div>
    );
  if (!me) return <LoginPage />;
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<ProjectsPage />} />
        <Route path="projects/:id" element={<ProjectPage />} />
        <Route path="director" element={<DirectorPage />} />
        <Route path="characters" element={<CharactersPage />} />
        <Route path="backgrounds" element={<BackgroundsPage />} />
        <Route path="products" element={<ProductsPage />} />
        <Route path="brand" element={<BrandPage />} />
        <Route path="gpu" element={<GpuPage />} />
        {isAdmin && <Route path="users" element={<UsersPage />} />}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
